"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JysLevel = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var risk_1 = require("../../model/risk");
var service_1 = require("../../../library/base/service");
var JysLevel = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(JysLevel, _super);
    function JysLevel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '理财产品风险判断';
        _this.code = '101050';
        _this.desc = '理财产品风险判断';
        _this.requestParams = new risk_1.JysLevelRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return JysLevel;
}(service_1.BaseService));
exports.JysLevel = JysLevel;
//# sourceMappingURL=jysLevel.js.map